"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const styles_1 = require("@material-ui/core/styles");
exports.mainBlue = "#005B96";
exports.iconGray = "#3C4257";
//applied these themes as styles  as theme cannot be applied TODO
exports.theme = styles_1.createTheme({
    typography: {
        fontFamily: ["Poppins"].join(","),
    },
    palette: {
        primary: {
            main: exports.mainBlue
        },
    }
});
exports.mainTitleStyle = {
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "30px",
    color: exports.mainBlue,
};
exports.gridBorder = {
    borderRadius: "10px",
    margin: "10px",
    padding: "40px",
    backgroundColor: "white"
};
exports.gridBorder2 = {
    borderRadius: "10px",
    marginTop: "10px",
    marginBottom: "10px",
    padding: "40px",
    backgroundColor: "white"
};
exports.textNameDiv = {
    display: "flex",
    paddingBottom: "10px",
    marginTop: "8px",
    flexDirection: "column"
};
exports.typeButtonSelected = {
    textAlign: "center",
    border: "2px solid #005B96",
    borderRadius: "10px",
    backgroundColor: "#F2F7FF",
    padding: "20px",
    cursor: "pointer",
};
exports.typeButtonNotSelected = {
    textAlign: "center",
    border: "2px solid #C1C9D2",
    borderRadius: "10px",
    padding: "20px",
    cursor: "pointer",
};
exports.FileUploadDiv = {
    border: "2px dashed #949494",
    backgroundColor: "white",
    borderRadius: "13px",
    padding: "20px",
    textAlign: "center",
    width: "80%",
    margin: "auto",
    height: "250px",
    marginTop: "16%",
};
exports.inputFields = {
    width: "80%",
    marginTop: "5px",
    marginBottom: "20px",
};
exports.inputFieldsfull = {
    width: "90%",
    marginTop: "5px",
    marginBottom: "20px",
};
exports.nextBotton = {
    backgroundColor: exports.mainBlue,
    marginLeft: "10px",
    minWidth: "40%",
    marginBottom: "30px",
    marginTop: "20px",
    textTransform: "none",
    color: "white",
};
exports.cancelBotton = {
    marginLeft: "10px",
    width: "40%",
    marginBottom: "30px",
    marginTop: "20px",
    textTransform: "none",
    color: "#949494",
    borderColor: "#949494",
};
exports.addAnother = {
    marginLeft: "10px",
    width: "40%",
    marginTop: "20px",
    textTransform: "none",
    color: "#949494",
    borderColor: exports.mainBlue,
    color: exports.mainBlue,
};
exports.fetchData = {
    backgroundColor: exports.mainBlue,
    marginLeft: "10px",
    width: "30%",
    marginBottom: "30px",
    marginTop: "20px",
    textTransform: "none",
    color: "white",
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
exports.MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
exports.remainingColumnDiv = {
    border: "1px solid rgba(0,0,0,0.26)",
    width: "100%",
    borderRadius: "8px",
    minHeight: "43px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
};
exports.remaingColumnChip = {
    margin: "5px",
    borderRadius: "4px",
    color: "#5E5C5C",
    backgroundColor: "#E2DFDF",
};
exports.handlingMissingValDiv = {
    backgroundColor: "white",
    padding: "30px",
    marginTop: "20px",
    marginRight: "20px",
    border: "1px solid #E2E5ED",
};
exports.handlingMissingValDivAnomaly = {
    backgroundColor: "white",
    padding: "60px",
};
//# sourceMappingURL=themes.js.map